'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WAMConstants = require('../constants/WAMConstants');

var _CommonUtil = require('./CommonUtil');

var _CommonUtil2 = _interopRequireDefault(_CommonUtil);

var _https = require('https');

var _https2 = _interopRequireDefault(_https);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FFCDataUtil = function () {
	function FFCDataUtil() {
		_classCallCheck(this, FFCDataUtil);

		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
	}

	// Singleton


	_createClass(FFCDataUtil, [{
		key: 'getProductSortIndex',
		value: function getProductSortIndex(product) {
			switch (product.id) {
				case 'KCCC':
					return 0;
				default:
					return product.sortIndex;
			}
		}
	}, {
		key: 'sortFFCProductArray',
		value: function sortFFCProductArray(productArr) {
			var _this = this;

			return productArr.sort(function (a, b) {
				return _this.getProductSortIndex(a) - _this.getProductSortIndex(b);
			});
		}
	}, {
		key: 'getHeaders',
		value: function getHeaders(_ref) {
			var accessToken = _ref.accessToken,
			    clientId = _ref.clientId,
			    appId = _ref.appId;

			var headers = {};
			headers['x-api-key'] = clientId;
			headers.Accept = 'application/json';
			if (accessToken) {
				headers.Authorization = 'Bearer ' + accessToken;
			}
			if (appId) {
				headers['x-adobe-app-id'] = appId;
			} else {
				headers['x-adobe-app-id'] = clientId;
			}
			return headers;
		}

		/**
   * Function to fetch all version FFC data
   *
   * @param sapCode (Required param) Sapcode of product whose data is to be fetched
   * @param platform
   * @param env Environment such as local, dev, qe, stage, prod
   * @param accessToken
   * @param clientId
   * @param appId
   * @param allVersionFFCData Client can pass all version FFC data if already fetched
   * @returns Promise that returns FFC data
   */

	}, {
		key: 'getFFCData',
		value: function getFFCData(_ref2) {
			var _this2 = this;

			var sapCode = _ref2.sapCode,
			    platform = _ref2.platform,
			    env = _ref2.env,
			    accessToken = _ref2.accessToken,
			    clientId = _ref2.clientId,
			    appId = _ref2.appId,
			    allVersionFFCData = _ref2.allVersionFFCData;

			return new Promise(function (resolve, reject) {
				if (allVersionFFCData) {
					resolve(allVersionFFCData);
				} else {
					var request = _https2.default.request({
						hostname: _WAMConstants.FFCUrls.products[env].replace('https://', ''),
						path: '/adobe-ffc-external/core/v4/products/all?sapCode=' + sapCode + '&channel=ccm&platform=' + platform,
						headers: _this2.getHeaders({ accessToken: accessToken, clientId: clientId, appId: appId })
					}, function (res) {
						var data = '';
						res.on('data', function (chunk) {
							return data += chunk;
						});
						res.on('end', function () {
							var response = JSON.parse(data);
							var ccmChannel = response && response.channel.find(function (channel) {
								return channel.name === 'ccm';
							});
							var productArr = ccmChannel ? ccmChannel.products.product : undefined;
							var allVersionsFFCProductList = void 0;
							if (productArr) {
								productArr = _this2.sortFFCProductArray(productArr);
								allVersionsFFCProductList = productArr.filter(_CommonUtil2.default.isVersionEnabled);
								allVersionsFFCProductList = allVersionsFFCProductList.sort(function (a, b) {
									return _CommonUtil2.default.compareVersionNumbers(a.version, b.version);
								});
							}
							resolve(allVersionsFFCProductList);
						});
					});
					request.on('error', function (e) {
						reject(e);
					});
					request.end();
				}
			});
		}

		/**
   * Get update description from FFC CDN endpoint
   * @param sapCode
   * @param version
   * @param platform
   * @param env
   * @param xAdobeAppId
   * @param locale
   * @returns {Promise}
   */

	}, {
		key: 'getUpdateDecription',
		value: function getUpdateDecription(_ref3) {
			var _this3 = this;

			var sapCode = _ref3.sapCode,
			    version = _ref3.version,
			    platform = _ref3.platform,
			    env = _ref3.env,
			    xAdobeAppId = _ref3.xAdobeAppId,
			    locale = _ref3.locale;

			return new Promise(function (resolve, reject) {
				var request = _https2.default.request({
					hostname: _WAMConstants.FFCUrls.productUpdateDesc[env].replace('https://', ''),
					path: '/core/v1/update/description?name=' + sapCode + '&version=' + version + '&platform=' + platform + '&language=' + locale + '&arg=' + Math.random(),
					headers: _this3.getHeaders({ clientId: xAdobeAppId })
				}, function (res) {
					var data = '';
					res.on('data', function (chunk) {
						return data += chunk;
					});
					res.on('end', function () {
						var response = void 0;
						try {
							response = JSON.parse(data);
						} catch (e) {
							reject(data);
						}
						resolve(response);
					});
				});
				request.on('error', function (e) {
					reject(e);
				});
				request.end();
			});
		}
	}]);

	return FFCDataUtil;
}();

exports.default = new FFCDataUtil();